import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { FormContainer, FormSection } from '../../styles';
import { employeesApi } from '../../../../../services/api';
import LoadingSpinner from '../../../../common/LoadingSpinner';
import EmptyState from '../../../../common/EmptyState';
import ResponsibilityCard from '../../../components/ResponsibilityCard';

const Responsibilities = ({ employeeId }) => {
  const [responsibilities, setResponsibilities] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchResponsibilities = async () => {
      try {
        setIsLoading(true);
        const response = await employeesApi.getManagerHistory(employeeId);
        setResponsibilities(response.data || []);
      } catch (error) {
        console.error('Failed to fetch responsibilities:', error);
        setResponsibilities([]);
      } finally {
        setIsLoading(false);
      }
    };

    if (employeeId) {
      fetchResponsibilities();
    }
  }, [employeeId]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <FormContainer>
      <FormSection>
        {responsibilities.length === 0 ? (
          <EmptyState
            title="No Responsibilities Found"
            description="This individual has no manager responsibilities recorded."
          />
        ) : (
          <>
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" color="text.secondary">
                <strong>{responsibilities.length}</strong> {responsibilities.length === 1 ? 'responsibility' : 'responsibilities'} found
              </Typography>
            </Box>
            <Grid
              container
              spacing={3}
              sx={{
                width: '100%',
                margin: '0 auto',
                display: 'grid',
                gridTemplateColumns: {
                  xs: '1fr',
                  sm: 'repeat(2, 1fr)',
                  md: 'repeat(3, 1fr)',
                  lg: 'repeat(3, 1fr)',
                  xl: 'repeat(3, 1fr)'
                },
                gap: '24px',
                '& .MuiGrid-item': {
                  padding: '0',
                  width: '100%'
                }
              }}
            >
              {responsibilities.map(responsibility => (
                <Grid item key={responsibility.id}>
                  <ResponsibilityCard responsibility={responsibility} />
                </Grid>
              ))}
            </Grid>
          </>
        )}
      </FormSection>
    </FormContainer>
  );
};

export default Responsibilities;
